import './scss/style.scss';
import LayoutNavigation from './navigation/LayoutNavigation';

function App() {
  return (
    <div className="App">
      <LayoutNavigation />
    </div>
  );
}

export default App;
